import { makeStyles, type Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(20),
    },
  },
  bodyMessage: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: "#000",
  },
  actions: {
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  primary: {
    background: "#0473FF",
    color: "#FFF",
    borderRadius: "6.25rem",
    padding: "0.688rem 1.875rem",
    "&:hover": {
      background: "#0236B0",
      color: "#FFF",
    },
  },
  secondary: {
    color: "#0473FF",
    borderRadius: "6.25rem",
    padding: "0.688rem 1.875rem",
    "&:hover": {
      background: "#D6E8FF",
      color: "#0473FF",
    },
  },
}));
